import { createGlobalStyle, styled } from 'styled-components';
import { breakpoints } from "../../../../../utils/styledBreakpoints";

export const GlobalStyle = createGlobalStyle`
    .dx-button {
        outline: 1px solid white;
        box-shadow: none !important;
        padding: 0.625rem 1.25rem;
        min-width: unset;
        border: 2px solid var(--button-primary-color);
    }

    .dx-button-text {
        font-size: 0.875rem;
    }
`;